/*
 * @Author: Src
 * @Date: 2026-09-01 14:27:11
 * @LastEditTime: 2026-09-11 15:20:28
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/supplyChainRouter/purchaseOrderRoutes.ts
 * @Description: 经销商采购单模块
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import PurchaseOrder from '@/views/supplyChain/distributor/PurchaseOrder.vue';
import { AuthEnum } from '@/services/permission.service';


const purchaseOrderRoutes: RouteConfig = {
    path: '/purchaseOrder',
    name: 'purchaseOrder',
    component: Main,
    meta: { title: '采购单列表' },
    redirect: {
      name: 'purchaseOrderList',
    },
    children: [
      {
        path: 'list',
        name: 'purchaseOrderList',
        component: PurchaseOrder,
        meta: { title: '采购单列表' },
        props: {
          auth: [AuthEnum.经销商采购单列表],
        },
      },
    ],
  };
export default purchaseOrderRoutes;
